import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import HttpsRedirect from 'react-https-redirect';
import {
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import App from '@routes/App';

import registerServiceWorker from './registerServiceWorker';
import { getStore } from './store/store';

import './styles/index.scss';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#449aff' },
    secondary: { main: '#26c6da' },
    error: { main: '#ff4e00' },
  },
});

let appContainer = (
  <BrowserRouter>
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <App />
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  </BrowserRouter>
);

if (!window.location.host.includes('process-general.next.mrx.gd')) {
  appContainer = (
    <HttpsRedirect>
      {appContainer}
    </HttpsRedirect>
  );
}

ReactDOM.render(
  <Provider store={getStore()}>
    {appContainer}
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js